// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --charcoal: rgb(38, 40, 43);
}

body {
  margin: 0;
  background-color: white;
}

#website-body {
  max-width: 1500px;
  margin: auto;
}

.wrapper-main {
  margin: clamp(0.45rem, 1.4vw, 1rem) clamp(0.75rem, 2.5vw, 1.75rem) 1.25rem;
  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(249, 250, 252) 100%);
  border: 1px solid rgba(38, 40, 43, 0.12);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 14px 28px rgba(16, 18, 20, 0.08);
}

.wrapper-content {
  width: 100%;
  height: 100%;
}

.navbar {
  width: 100%;
  height: auto;
  background-color: var(--charcoal);
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.navitem {
  height: 80%;
  width: clamp(115px, 10rem, 11rem);
  text-align: center;
  padding-top: .2rem;
  padding-bottom: .6rem;
  margin-top: .2rem;
  /* padding-left: 1.5rem;
  padding-right: 1.5rem;; */
}

.navitem>a {
  color: whitesmoke;
  font-family: serif;
  font-size: 1.4rem;
}

@media (max-width: 450px) {
  .navbar {
    gap: 0.25rem;
  }

  .navitem {
    width: auto;
    padding-left: 0.55rem;
    padding-right: 0.55rem;
  }

  .navitem>a {
    font-size: 1.15rem;
  }
}

.navitem>a:hover,
.navitem>a:focus,
.active {
  color: goldenrod
}

.invertColor {
  filter: invert(100%);
}

.profileImg {
  width: clamp(150px, 15%, 225px);
  height: auto;
  display: block;
  margin: 0 auto;
  border: 2px solid rgba(38, 40, 43, 0.22);
  border-radius: 50%;
  box-shadow: 0 12px 24px rgba(16, 18, 20, 0.14);
}

#imgWrapper {
  width: 100%;
  display: inline-block;
}

#banner {
  background: transparent;
}

#spacer {
  height: auto;
  width: 100%;
  background-color: transparent;
  overflow: visible;
  display: block;
  padding-top: clamp(0.45rem, 1.2vw, 0.9rem);
  padding-bottom: clamp(0.25rem, 0.8vw, 0.5rem);
}

#footer {
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  color: transparent;
  padding-top: 0.15rem;

  position: fixed;
  bottom: 0px;
  left: 0px;
}

#socials-wrapper {
  background-color: var(--charcoal);
  color: whitesmoke;
  padding-bottom: 0.5rem;
}

#socials-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: clamp(200px, 40%, 700px);
  margin: auto;
  border-top: 2px outset whitesmoke;
}

#socials-container>* {
  width: 25%;
  margin-top: 0.4rem;
}

#socials-container>* a {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  text-decoration: none;
  color: whitesmoke;
}

#socials-container>* img {
  max-width: 30px;
  height: auto;
  margin: auto;
}

#socials-container>* p {
  margin: auto;
  display: inline;
  padding-top: 0.1rem;
}

@media only screen and (max-width: 800px) {
  #socials-container>* p {
    display: none;
  }
}

@media (max-width: 600px) {
  .wrapper-main {
    margin: 0.35rem 0.5rem 0.85rem;
    border-radius: 12px;
    box-shadow: 0 8px 18px rgba(16, 18, 20, 0.08);
  }
}
`, "",{"version":3,"sources":["webpack://./src/public/css/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,mFAAmF;EACnF,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB;2BACyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,cAAc;EACd,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,6CAA6C;EAC/C;AACF","sourcesContent":[":root {\n  --charcoal: rgb(38, 40, 43);\n}\n\nbody {\n  margin: 0;\n  background-color: white;\n}\n\n#website-body {\n  max-width: 1500px;\n  margin: auto;\n}\n\n.wrapper-main {\n  margin: clamp(0.45rem, 1.4vw, 1rem) clamp(0.75rem, 2.5vw, 1.75rem) 1.25rem;\n  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(249, 250, 252) 100%);\n  border: 1px solid rgba(38, 40, 43, 0.12);\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 14px 28px rgba(16, 18, 20, 0.08);\n}\n\n.wrapper-content {\n  width: 100%;\n  height: 100%;\n}\n\n.navbar {\n  width: 100%;\n  height: auto;\n  background-color: var(--charcoal);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.navitem {\n  height: 80%;\n  width: clamp(115px, 10rem, 11rem);\n  text-align: center;\n  padding-top: .2rem;\n  padding-bottom: .6rem;\n  margin-top: .2rem;\n  /* padding-left: 1.5rem;\n  padding-right: 1.5rem;; */\n}\n\n.navitem>a {\n  color: whitesmoke;\n  font-family: serif;\n  font-size: 1.4rem;\n}\n\n@media (max-width: 450px) {\n  .navbar {\n    gap: 0.25rem;\n  }\n\n  .navitem {\n    width: auto;\n    padding-left: 0.55rem;\n    padding-right: 0.55rem;\n  }\n\n  .navitem>a {\n    font-size: 1.15rem;\n  }\n}\n\n.navitem>a:hover,\n.navitem>a:focus,\n.active {\n  color: goldenrod\n}\n\n.invertColor {\n  filter: invert(100%);\n}\n\n.profileImg {\n  width: clamp(150px, 15%, 225px);\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  border: 2px solid rgba(38, 40, 43, 0.22);\n  border-radius: 50%;\n  box-shadow: 0 12px 24px rgba(16, 18, 20, 0.14);\n}\n\n#imgWrapper {\n  width: 100%;\n  display: inline-block;\n}\n\n#banner {\n  background: transparent;\n}\n\n#spacer {\n  height: auto;\n  width: 100%;\n  background-color: transparent;\n  overflow: visible;\n  display: block;\n  padding-top: clamp(0.45rem, 1.2vw, 0.9rem);\n  padding-bottom: clamp(0.25rem, 0.8vw, 0.5rem);\n}\n\n#footer {\n  width: 100%;\n  text-align: center;\n  font-size: 0.75rem;\n  color: transparent;\n  padding-top: 0.15rem;\n\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n}\n\n#socials-wrapper {\n  background-color: var(--charcoal);\n  color: whitesmoke;\n  padding-bottom: 0.5rem;\n}\n\n#socials-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: clamp(200px, 40%, 700px);\n  margin: auto;\n  border-top: 2px outset whitesmoke;\n}\n\n#socials-container>* {\n  width: 25%;\n  margin-top: 0.4rem;\n}\n\n#socials-container>* a {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: center;\n  text-decoration: none;\n  color: whitesmoke;\n}\n\n#socials-container>* img {\n  max-width: 30px;\n  height: auto;\n  margin: auto;\n}\n\n#socials-container>* p {\n  margin: auto;\n  display: inline;\n  padding-top: 0.1rem;\n}\n\n@media only screen and (max-width: 800px) {\n  #socials-container>* p {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .wrapper-main {\n    margin: 0.35rem 0.5rem 0.85rem;\n    border-radius: 12px;\n    box-shadow: 0 8px 18px rgba(16, 18, 20, 0.08);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
